<template>
    <div id="mainpage">
        <Navbar />
        <section class="hero topsection has-background-light">
            <div class="hero-body">
                <div class="container">
                    <img height="136" width="460" alt="AEMP logo" src="./assets/logoAEMP_v2b.png">
                    <h1 class="is-size-6 has-text-centered has-text-dark is-hidden">
                        Association des Equipes Mobiles en Psychiatrie
                    </h1>
                    <br><br>
                    <div v-if="!loading && page.is_active && $route.name == 'landing'" v-bind:style="styleObject" class="boxy enavant">
                        <div class="columns">
                            <div class="column" v-if="page.poster && page.poster.path">
                                <img alt="img" :src="page.poster.path" width="280" @error="imageUrlAlt">
                            </div>
                            <div class="column">
                                <div class="has-text-right">
                                    <a :href="'/'+page.programme" v-if="page.programme" target="_blank" class="button is-dark is-outlined">
                                        <b-icon icon="file-document-box-outline">
                                        </b-icon><span>Programme</span>
                                    </a>&nbsp;
                                    <a :href="'/'+page.inscription_page.slug" v-if="inscriptions" class="button is-dark is-outlined">
                                        <b-icon icon="link">
                                        </b-icon><span>Inscription</span>
                                    </a>
                                </div><br>
                                <h2 class="title">
                                    {{page.title}}
                                </h2>
                                <h4 class="subtitle">
                                    <b>{{page.subtitle}}</b><br><i><span v-if="page.inscription_open">Les inscriptions sont ouvertes!</span><span v-else></span></i>
                                </h4>
                                <flip-countdown v-if="flip" :deadline="dateh"></flip-countdown>
                                <i v-if="page.inscription_date_limite">{{page.inscription_date_limite}}</i>

                                <div class="description" v-if="page.description" v-html=" page.description"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="has-background-light" id="voir">
            <div class="columns is-mobile has-text-left"> <br><br>
                <div class="column is-10 is-offset-1">
                    <router-view></router-view>
                </div>
            </div>
            <br>
        </div>
        <footer class="has-background-dark has-text-light">
            <p class="test">Association des Equipes Mobiles en Psychiatrie (AEMP)</p>
            <p class="footerlinks">
                <router-link to="/page/credits#voir">Crédits</router-link>//
                <router-link to="/page/mentions-legales#voir">Mentions légales</router-link>
            </p>
        </footer>
    </div>
</template>
<script>
import Navbar from './components/Navbar.vue'
import FlipCountdown from 'vue2-flip-countdown'
const axios = require('axios');
export default {
    data: function() {
        return {
            flip: true,
            inscriptions: true,
            loading: true,
            page: null,
            error: null,
            dateh: null,
            styleObject: {
                backgroundColor: 'transparent',
                padding: '20px 20px'
                //fontSize: '13px'
            }
        }
    },
    name: 'App',
    components: {
        Navbar,
        FlipCountdown,
    },
    created() {
        this.fetchData()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        imageUrlAlt(event) {
            event.target.src = "https://buefy.org/static/img/placeholder-1280x960.png"
        },
        fetchData() {
            this.error = this.page = null
            this.loading = true
            var vm = this
            var fetchurl = this.$api_url_countdown + '&filter[is_active]=1&populate=1'
            axios({
                    method: 'get',
                    url: fetchurl
                    /*method: 'post',
                    url: fetchurl,
                    headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        //filter: { is_active: 1 },
                        //fields: {fieldA:1},
                        populate: 1, // resolve linked collection items
                        lang: 'fr' // return normalized language fields (fieldA_de => fieldA)
                    })*/
                }).then(function(response) {
                    vm.loading = false
                    if (response.data) {
                        vm.page = response.data
                        vm.inscriptions = vm.page.inscription_page
                        vm.flip = vm.page.active_flip
                        vm.styleObject.backgroundColor = vm.page.bgcolor
                        vm.dateh = vm.page.date + ' ' + vm.page.heure_debut + ':00'
                        vm.error = null
                    } else {
                        vm.page = null
                        vm.error = 'page introuvable'
                    }
                })
                .catch(function() {
                    //console.log("Erreur ! Impossible d'accéder à l'API." + error)
                    vm.error = 'page introuvable'
                })

        }
    }

}
</script>
<style>
h3 {
    line-height: 1.4em !important;
}

h3:after {
    content: "";
    display: block;
    width: 70px;
    /*border-bottom: 6px solid #ffd91c;*/
    border-bottom: 6px solid hsl(141, 53%, 53%);
    margin-bottom: 5px;
}

.description{
    padding-top: 25px;
}

.enavant{
    border-bottom: 1px solid #aaa;
    border-top: 1px solid #aaa;
}

#mainpage {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
}

.barre {
    text-decoration: line-through;
}

footer {
    border-top: 1px solid black;
    /*background-color: hsl(0, 0%, 29%);*/
    padding: 12px;
}

.footerlinks a {
    color: white;
    padding: 10px;
}

.footerlinks a:hover {
    color: white;
    text-decoration: underline;
}
</style>